import { styled } from "@mui/material/styles";

export const MainContainer = styled("div")(({ theme }) => ({
  marginLeft: "auto",
  marginRight: "auto",
  padding: "0 1rem",
  maxWidth: "112.4rem",
  minHeight: "calc(100% - 26rem)",
  [theme.breakpoints.up("sm")]: {
    padding: "0 2rem"
  }
}));

export const AppWrapper = styled("div")({
  height: "100%"
});
